export default __webpack_public_path__ + "static/media/imagem-assinatura.916b2086.png";